<template lang="pug">
  span.page-info(v-if="totalItems > perPage")
    | {{ ((perPage * (currentPage + 1)) - perPage) + 1 }} -
    | {{ Math.min(totalItems, perPage * (currentPage + 1)) }}
    | de {{ totalItems }}
</template>

<script>
export default {
  name: 'PageInfo',
  props: {
    totalItems: {required: true, type: Number},
    perPage: {required: true, type: Number},
    currentPage: {required: true, type: Number}
  }
}
</script>

<style scoped lang="scss">
.page-info {
  color: var(--texto-suave);
  font-family: var(--texto-tipografia, var(--front-font));
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
}
</style>
